/**
 * Soft launch: when enabled, guests may only open paths in LAUNCH_MODE_GUEST_PATHS.
 * CRA exposes only vars prefixed with REACT_APP_ — set in `.env` / `.env.local`:
 * REACT_APP_LAUNCH_MODE=true
 *
 * Only the string `true` (case-insensitive, trimmed) enables launch mode so values like
 * `false`, empty, or unset behave as “off” (matches production CI vars).
 */
export function isLaunchMode() {
  const raw = process.env.REACT_APP_LAUNCH_MODE;
  if (raw == null || String(raw).trim() === '') return false;
  return String(raw).trim().toLowerCase() === 'true';
}

/** Business provider onboarding paths allowed for guests during launch mode. */
export const LAUNCH_MODE_BUSINESS_SIGNUP_PATHS = [
  '/provider-signup',
  '/join-existing-business',
  '/terms',
  '/privacy',
  '/business-terms',
  '/sms-terms',
  '/verify-email',
  '/forgot-password',
  '/reset-password',
];

/** Pathnames allowed without a logged-in user while launch mode is on. */
export const LAUNCH_MODE_GUEST_PATHS = new Set([
  '/launch',
  '/login',
  ...LAUNCH_MODE_BUSINESS_SIGNUP_PATHS,
]);

/** Launch-mode routes that use the simplified launch nav bar instead of RefinedNavBar. */
export const LAUNCH_MODE_LAUNCH_NAV_PATHS = new Set([
  '/launch',
  '/login',
  '/provider-signup',
  '/join-existing-business',
]);

export function normalizeLaunchPathname(pathname) {
  return pathname.length > 1 && pathname.endsWith('/')
    ? pathname.slice(0, -1)
    : pathname;
}

export function isLaunchModeLaunchNavPath(pathname) {
  return LAUNCH_MODE_LAUNCH_NAV_PATHS.has(normalizeLaunchPathname(pathname));
}
